module.exports = __webpack_public_path__ + "static/img/positionImg.9308c25c.png";